export default __webpack_public_path__ + "static/media/upload.c4f43211.svg";